module.exports = __webpack_public_path__ + "static/media/pre_cast_haz_lev.84134800.png";